/* eslint-disable no-console */
import {DownloadOutlined} from '@ant-design/icons';
import {
  Button,
  Col,
  Flex,
  Progress,
  Divider,
  Timeline,
  Tooltip,
  Dropdown
} from 'antd';
import React, {useContext, useState} from 'react';
import {useNavigate} from 'react-router';

import UpgradeButton from '../../../components/UpgradeButton/UpgradeButton';
import {GenerateReportButtonText} from '../../../constants/Common';
import {Routes, subRoutes} from '../../../constants/Routes';
import {reportTypeEnum} from '../../../services/constants/enum';
import downloadReportAPI from '../../../services/modules/ESG/ESGReportDownload';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import showMessage from '../../../utils/showMessage';
import {shouldBlockReportAccess} from '../../../utils/SubscriptionHelper';
import {frameworkRoute} from '../constants/frameworkRoutes';
import {
  ReportExtensionPDFOnly,
  ReportExtensionsLabels
} from '../constants/FrameWorksConst';
import {SelectedYear} from '../constants/YearContext';

const CBAM_STATIC_REPORT_URL = `${process.env.REACT_APP_PUBLIC_ASSETS_URL}/Bharat+Steel+Report.pdf`;

const Framework: React.FC<{item: any; data: any; isBlock: boolean}> = ({
  item,
  data,
  isBlock
}) => {
  const {
    icon,
    title,
    content,
    buttonText,
    timeline,
    route,
    timeLineRender,
    isComingSoon = false
  } = item;
  const navigate = useNavigate();
  const selectedYear = useContext(SelectedYear);
  const pillarData = data?.pillars;
  const companyData = useCompanyStore.getState().companyDetails;
  const userDetails = useUserStore.getState().userDetails;

  const [generateLink, setGenerateLink] = useState<boolean>();

  const reportTypeMap: Record<string, string> = {
    [frameworkRoute.BRSR]: reportTypeEnum.brsr,
    [frameworkRoute.GRI]: reportTypeEnum.gri,
    [frameworkRoute.TCFD]: reportTypeEnum.tcfd,
    [frameworkRoute.CDP_SME]: reportTypeEnum.cdp,
    [frameworkRoute.CDP_CORPORATE]: reportTypeEnum.cdp_corporate,
    [frameworkRoute.CBAM]: reportTypeEnum.cbam_iron_and_steel
  };
  const handleGenerateReportClick = (e: any, reportType: string) => {
    if (reportType === frameworkRoute.CBAM) {
      if (CBAM_STATIC_REPORT_URL) {
        window.open(CBAM_STATIC_REPORT_URL, '_blank');
      }

      return;
    }

    const extension = e?.key || 'pdf'; // Default to 'pdf' if no key provided
    setGenerateLink(true);

    // Map framework route to report type enum

    const mappedReportType = reportTypeMap[reportType] || reportType;

    downloadReportAPI(
      selectedYear,
      mappedReportType as any,
      extension,
      userDetails?._id
    )
      .then((response) => {
        // GRI uses 'url' (singular), others use 'urls' (plural)
        const reportLink = response.data.url || response.data.urls;
        const fileName = reportLink.split('/');
        const link = document.createElement('a');
        link.href = reportLink;
        link.target = '_blank';
        link.download = fileName?.[fileName.length - 1];
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showMessage(response.data);
        setGenerateLink(false);
      })
      .catch(() => {
        setGenerateLink(false);
      });
  };

  const menuProps = {
    items: ReportExtensionsLabels,
    onClick: (e: any) => {
      handleGenerateReportClick(e, item?.route);
    }
  };
  const menuPropsPDFOnly = {
    items: ReportExtensionPDFOnly,
    onClick: (e: any) => {
      handleGenerateReportClick(e, item?.route);
    }
  };

  return (
    <Col className="gutter-row" span={8}>
      {isComingSoon ? (
        <Flex vertical className="comingSoon">
          <div className="title">Coming Soon....</div>
          <div className="title">{title}</div>
        </Flex>
      ) : (
        <Flex vertical className="frameworkFlex">
          <Flex vertical>
            <Flex className="framework">
              <div className="logo">
                <img
                  id="image1"
                  src={icon}
                  alt="Logo"
                  width={122}
                  height={122}
                />
              </div>
              <div className="title">
                <div className="mainTitle">{title}</div>
                <div className="para">{content}</div>
                <div className="progress">
                  <div className="progressTab">
                    <div className="progresstitle">Reporting Progress</div>
                    <Progress
                      percent={data?.completion ?? 0}
                      showInfo={true}
                      strokeColor="#5BCEAE"
                      trailColor="rgb(91 206 174 / 20%)"
                      className="bar"
                    />
                  </div>
                  {/* <div className="progressTab">
                    <div className="progresstitle">Prefilled</div>
                    <Progress
                      percent={data?.prefilled ?? 0}
                      showInfo={true}
                      strokeColor="#46BBE0"
                      trailColor="rgb(70 187 224 / 20%)"
                      className="bar"
                    />
                  </div> */}
                </div>
              </div>
            </Flex>
            <Flex
              style={{justifyContent: 'space-between', alignItems: 'center'}}
            >
              {reportTypeMap[item?.route] ? (
                shouldBlockReportAccess(item?.route) ? (
                  <UpgradeButton title={GenerateReportButtonText()} />
                ) : (
                  <>
                    {selectedYear &&
                    (item?.route === frameworkRoute.BRSR ||
                      item?.route === frameworkRoute.GRI) ? (
                      <Dropdown
                        menu={
                          item?.route === frameworkRoute.BRSR
                            ? menuProps
                            : menuPropsPDFOnly
                        }
                        trigger={['click']}
                      >
                        <Button
                          type="default"
                          icon={<DownloadOutlined />}
                          style={{marginBottom: '10px'}}
                          download
                          loading={generateLink}
                        >
                          {GenerateReportButtonText(generateLink)}
                        </Button>
                      </Dropdown>
                    ) : (
                      <Button
                        type="default"
                        icon={<DownloadOutlined />}
                        style={{marginBottom: '10px'}}
                        download
                        loading={generateLink}
                        onClick={(e: any) => {
                          handleGenerateReportClick(e, item?.route);
                        }}
                      >
                        {GenerateReportButtonText(generateLink)}
                      </Button>
                    )}
                  </>
                )
              ) : (
                <Button
                  type="default"
                  icon={<DownloadOutlined />}
                  style={{
                    marginBottom: '10px',
                    opacity: 0.6,
                    cursor: 'not-allowed'
                  }}
                  disabled
                >
                  Coming Soon
                </Button>
              )}
              <Tooltip title={!selectedYear ? 'Please select a year' : ''}>
                <div>
                  {isBlock ? (
                    <UpgradeButton title="Upgrade" />
                  ) : (
                    <Button
                      className={`continue ${!selectedYear ? 'disabled' : ''}`}
                      disabled={!selectedYear}
                      onClick={() => {
                        navigate(
                          `${Routes.ESG}${subRoutes.framework}/${route}?selectedYear=${selectedYear}`,
                          {state: pillarData}
                        );
                      }}
                    >
                      {buttonText}
                    </Button>
                  )}
                </div>
              </Tooltip>
            </Flex>
          </Flex>
          <Divider className="divider" />
          <div className="pillerText">Pillars</div>
          <Flex className="pillerFlex">
            <div className="pillers">
              <div className="piller">
                <Timeline style={{width: '100%'}}>
                  {timeline
                    ?.filter((item: any) => {
                      // Filter by category if provided
                      const categoryMatch = item?.category
                        ? item?.category === companyData?.category
                        : true;

                      // Filter by subCategory if provided (optional)
                      const subCategoryMatch =
                        item?.subCategory !== undefined
                          ? item?.subCategory === companyData?.subCategory
                          : true;

                      return categoryMatch && subCategoryMatch;
                    })
                    .map((item: any, i: number) => {
                      const pillar = pillarData?.find((pItem: any) => {
                        return (
                          pItem?.name.toLowerCase() ===
                          item?.ptitle.toLowerCase()
                        );
                      });

                      return (
                        <Timeline.Item className="timeline" key={i}>
                          <div className="ptitle">{item.ptitle}</div>
                          <Flex className="content">
                            {timeLineRender.map(
                              (timelineItem: any, index: number) => {
                                const {icon, title} = timelineItem;
                                const isModule = title === 'No. of Modules';

                                return (
                                  <React.Fragment key={index}>
                                    <Flex className="modules">
                                      <Flex className="imgFlex">
                                        <img
                                          className="img"
                                          id="mods"
                                          src={icon}
                                          alt="Logo"
                                        />
                                      </Flex>
                                      <Flex
                                        className={
                                          isBlock
                                            ? 'modText-blocked'
                                            : 'modText'
                                        }
                                      >
                                        {isBlock ? (
                                          <div>{title}</div>
                                        ) : (
                                          <div
                                            onClick={() => {
                                              if (selectedYear) {
                                                navigate(
                                                  // eslint-disable-next-line max-len
                                                  `${Routes.ESG}${subRoutes.framework}/${item.routes}?selectedYear=${selectedYear}`,
                                                  {state: pillar}
                                                );
                                              } else {
                                                showMessage({
                                                  status: 'info',
                                                  message:
                                                    'Please select a year'
                                                });
                                              }
                                            }}
                                          >
                                            {title}
                                          </div>
                                        )}
                                        <div className="number">
                                          {isModule
                                            ? pillar?.modules ?? 0
                                            : `${
                                                pillar?.questionsAnswered ?? 0
                                              }/${pillar?.totalQuestions ?? 0}`}
                                        </div>
                                      </Flex>
                                    </Flex>
                                  </React.Fragment>
                                );
                              }
                            )}
                          </Flex>
                        </Timeline.Item>
                      );
                    })}
                </Timeline>
              </div>
            </div>
          </Flex>
        </Flex>
      )}
    </Col>
  );
};

export default Framework;
